import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import axios from 'axios'
import 'amfe-flexible'

import { Icon, Field, Cell, CellGroup, Toast, Button, Search, Dialog } from 'vant';
const app = createApp(App)
app.config.globalProperties.token = null
app.use(router)
app.use(ElementPlus)
app.use(Icon);
app.use(Toast);
app.use(Field);
app.use(Cell);
app.use(CellGroup);
app.use(Button);
app.use(Search);
app.use(Dialog);
app.mount('#app')
 
 

const instance = axios.create({
    timeout: 5000,
    baseURL:"http://1.1.1.1:8993/"

})
 
//将axios挂载到原型对象上，vue3相比vue2有所改变，vue2这样写：Vue.prototype.$http = axios
app.config.globalProperties.$axios = instance;